module.exports = __webpack_public_path__ + "img/vazamento.19bbb1cb.png";